import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseAntiBot from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAntiBot';

const pageSchema = PlanGetSchema.pages.antiBot;
const pageId = pageSchema.pageId;

function PlanAntiBot({
    planObject,
    setPlanData,
    setEditorPageId
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseAntiBot
            pageData={pageData}
            setObjectData={setPlanData}
            setEditorPageId={setEditorPageId}
        />
    );
}

export default PlanAntiBot;